var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { class: _vm.enableConfigForm },
      [
        _vm._l(
          _vm.idpConfig[_vm.identityProvider]["idpGeneralFields"],
          function(field) {
            return _c(
              "v-layout",
              { key: field.display_name, attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { staticClass: "pa-2 ma-2 pt-5", attrs: { xs3: "" } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(field.display_name) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: "pa-2", attrs: { xs8: "" } },
                  [
                    _c("v-text-field", {
                      class: _vm.enableConfigForm,
                      attrs: { placeholder: field.display_name },
                      model: {
                        value: _vm.ssoFormData[field.apiField],
                        callback: function($$v) {
                          _vm.$set(_vm.ssoFormData, field.apiField, $$v)
                        },
                        expression: "ssoFormData[field.apiField]"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }
        ),
        _vm._v(" "),
        _c(
          "v-layout",
          { attrs: { row: "", wrap: "" } },
          [
            _c(
              "v-flex",
              { staticClass: "pa-2 ma-2 pt-4", attrs: { xs3: "" } },
              [_vm._v("\n                Api access\n            ")]
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "pb-2", attrs: { xs8: "" } },
              [
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.ssoConfigApiAccess,
                      callback: function($$v) {
                        _vm.ssoConfigApiAccess = $$v
                      },
                      expression: "ssoConfigApiAccess"
                    }
                  },
                  _vm._l(_vm.identityProviderApiLabels, function(idp, index) {
                    return _c("v-radio", {
                      key: index,
                      attrs: { label: idp.label, value: idp.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.idpConfig[_vm.identityProvider]["idpApiFields"], function(
          field
        ) {
          return _c(
            "v-layout",
            {
              key: field.display_name,
              class: !_vm.ssoConfigApiAccess ? "disabled" : "",
              attrs: { row: "", wrap: "" }
            },
            [
              _c(
                "v-flex",
                { staticClass: "pa-2 ma-2 pt-5", attrs: { xs3: "" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(field.display_name) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pa-2", attrs: { xs8: "" } },
                [
                  _c("v-text-field", {
                    class: _vm.enableConfigForm,
                    attrs: {
                      placeholder: field.display_name,
                      "append-icon":
                        field.apiField == "client_secret"
                          ? _vm.showSecret
                            ? "mdi-eye"
                            : "mdi-eye-off"
                          : "",
                      type:
                        field.apiField == "client_secret"
                          ? _vm.showSecret
                            ? "text"
                            : "password"
                          : ""
                    },
                    on: {
                      "click:append": function($event) {
                        field.apiField == "client_secret"
                          ? (_vm.showSecret = !_vm.showSecret)
                          : ""
                      }
                    },
                    model: {
                      value: _vm.ssoFormData[field.apiField],
                      callback: function($$v) {
                        _vm.$set(_vm.ssoFormData, field.apiField, $$v)
                      },
                      expression: "ssoFormData[field.apiField]"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }